export default __webpack_public_path__ + "static/media/nenok.3fb6fe6c.png";